module.exports = __webpack_public_path__ + "media/images/svgs/sub_menu/app/apple_share-1e63d2830bb1264a1821980c6da1d08b.svg";